<template>
  <b-modal
    id="delete-splash-screen-modal"
    title="Delete Splash Screen"
  >
    <h4 class="text-center">
      Are you sure you want to delete this splash screen?
    </h4>
    <template #modal-footer="{close}">
      <b-row style="width:100%">
        <b-col md="6">
          <b-button
            block
            variant="danger"
            @click="close"
          >
            Cancel
          </b-button>
        </b-col>
        <b-col md="6">
          <b-button
            block
            variant="primary"
            :disabled="submitting"
            @click="deleteHandler"
          >
            <BSpinner
              v-if="submitting"
              small
            />
            <span v-else>Confirm</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BButton,
  BSpinner, BRow, BCol,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import { errorNotification } from '@/utils/toast-notifications'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BModal,
    BButton,
    BSpinner,
    BRow,
    BCol,
  },
  props: {
    splashScreen: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const submitting = ref(false)
    const deleteHandler = async () => {
      try {
        submitting.value = true
        await axiosIns.delete(`/drivers/splash-screen/${props.splashScreen.id}`)
        ctx.emit('deleted')
        ctx.root.$bvModal.hide('delete-splash-screen-modal')
      } catch (err) {
        const msg = err.response?.data?.error?.error || 'An error occured'
        errorNotification(msg)
      } finally {
        submitting.value = false
      }
    }
    return {
      submitting,
      deleteHandler,
    }
  },
}
</script>

<style></style>
